import { useQueryClient } from '@tanstack/react-query';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { toast } from 'sonner';

import { PageTitle } from '@components/PageTitle';
import { queryKeys } from '@constants/queryKeys.constant';
import { updateServiceRequestCounts } from '@helpers/queryCache/updateTabCounts.helper';
import { sendEmailSearchParamsSchema } from '@services/emails/dtos/send.dto';

import { SendEmailForm } from '../@components/Emails/SendForm';

export const Route = createFileRoute(
  '/_layout/(private)/service-requests/$id/emails/send',
)({
  component: ServiceRequestEmailSend,
  validateSearch: search => {
    const { language, to } = sendEmailSearchParamsSchema.parse(search);

    if (!to) {
      toast.warning('Missing recipient email', {
        description:
          'The recipient email address is required to send an email.',
      });
      redirect({
        to: '..',
      });
    }

    return { to, language };
  },
});

function ServiceRequestEmailSend() {
  const { id } = Route.useParams();
  const { language, to } = Route.useSearch();
  const queryClient = useQueryClient();

  return (
    <>
      <PageTitle
        hasBackButton
        params={{ id }}
        title="Send email to requester"
        to="/service-requests/$id"
      />
      <SendEmailForm
        language={language}
        onSend={() =>
          updateServiceRequestCounts({
            delta: 1,
            field: 'emails',
            queryClient,
            serviceRequestId: id,
          })
        }
        queryKeyToInvalidate={queryKeys.emails.smartEventRequester(id)}
        recipientType="requester"
        serviceRequestId={id}
        to={to}
      />
    </>
  );
}
